// extracted by mini-css-extract-plugin
module.exports = {"detailRow":"detail-row_detailRow__1EqdA"};